import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-12" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "border border-white p-2 tracking-wider hover:text-slate-200 hover:border-slate-200 uppercase text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: `${_ctx.publicPath}cv.pdf`,
      download: "Dominika_Biedulska_CV"
    }, [
      _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.$t('btn')), 1)
    ], 8, _hoisted_2)
  ]))
}